// extracted by mini-css-extract-plugin
module.exports = {"container404":"__404_container404__WUPr7","h1Selector":"__404_h1Selector__1Trhx","spanSelector":"__404_spanSelector__vB4mF","pSelector":"__404_pSelector__2N_4j"};